import { z } from 'zod';

/**
 * Team create members DTO schema for inviting new team members
 * Validates a list of email addresses and the inviter identity
 */
const teamCreateMembersDtoSchema = z.object({
    emails: z.array(z.string().email()).min(1).max(10),
    invitedBy: z.string(),
});

export { teamCreateMembersDtoSchema };
//# sourceMappingURL=teamCreateMembersDto.js.map
